export default {
    estimates: [],
    drafts: [],
    activeEstimate: {
        startDate: new Date().toISOString().substr(0, 10),
        startTime: '08:30',
        total: 0.00,
        discountValue: null
    },
    manageEstimateDialog: false,
    deleteEstimateDialog: false
}
